<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="mb-0">
          <span
            >Detalle de Cotización #{{ quotation.code }}
            <template v-if="quotation.projection && $can('show', 'projections')">
              (basado en
              <router-link :to="{ name: 'ProjectionShow', params: { id: quotation.projection.id } }">
                Proyección </router-link
              >)
            </template>
          </span>
          <badge v-if="quotation.state" :type="stateType" class="float-right">
            {{ stateLabel }}
          </badge>
        </h3>
      </div>

      <div class="card-body">
        <!--        <div class="row mb-0">-->
        <!--          <div class="col-sm-12">-->
        <!--            <router-link :to="{name: 'QuotationEdit', params: { id: quotation.id }}"-->
        <!--                         class="btn btn-link btn-sm btn-fill btn-wd float-right"-->
        <!--                         v-if="canEditQuotation">-->
        <!--              <i class="fas fa-pen mr-1"></i>Editar-->
        <!--            </router-link>-->
        <!--          </div>-->
        <!--        </div>-->

        <quotation-info
          :campaign="quotation.campaign"
          :quotation-date="quotation.date"
          :producer="quotation.producer"
          :quotation-code="quotation.code"
          :user-name="quotation.user.name"
        />

        <hr />
        <quotation-header :quotation="quotation" />

        <hr />
        <quotation-items-list
          v-if="quotation.items.length > 0"
          :add="false"
          :dollar-quote="+quotation.dollarQuote"
          :edit="false"
          :items="quotation.items"
          :quotation="quotation.id"
        />
        <h2 v-else class="font-weight-normal">Sin artículos.</h2>

        <template v-if="quotationsHasImages">
          <hr />
          <quotation-images-list :show-gallery="true" :pictures="quotation.pictures" />
        </template>

        <template v-if="showSendEmail">
          <hr />
          <div class="row mb-0">
            <div class="col-sm-12">
              <base-button type="success" class="float-right" @click="sendEmail"> Enviar e-mail </base-button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import QuotationStatesMixin from '@/mixins/quotationStatesMixin';
import QuotationInfo from './QuotationInfo';
import QuotationHeader from './QuotationHeader';
import QuotationItemsList from '../List/QuotationItemsList';
import QuotationImagesList from '../List/QuotationImagesList';
import swal from 'sweetalert2';

export default {
  components: {
    QuotationInfo,
    QuotationHeader,
    QuotationItemsList,
    QuotationImagesList,
  },

  mixins: [QuotationStatesMixin],
  props: {
    quotation: {
      type: Object,
      required: true,
    },

    quotationId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      stateType: 'warning',
      stateLabel: 'default',
      showSendEmail: false,
    };
  },

  computed: {
    quotationsHasImages() {
      return this.quotation.pictures !== null && this.quotation.pictures.length > 0;
    },
  },

  mounted() {
    this.stateType = this.getColor(this.quotation);
    this.stateLabel = this.quotation.state.label;
    this.showSendEmail = this.isQuotationCreated;
  },

  methods: {
    sendEmail() {
      this.$services
        .resource('quotations')
        .sendMail(this.quotationId)
        .then((res) => res.data.data)
        .then((data) => this.setSendedState(data));
    },

    setSendedState(data) {
      this.stateLabel = data.state.label;
      this.stateType = this.getColor(data);

      this.setNewState(data.state);

      swal({
        title: 'Listo!',
        text: 'La cotización ha sido enviada.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success',
        type: 'success',
      });
      this.showSendEmail = false;
    },
  },
};
</script>
